import React from "react";
// import SVLS_API from "../../../api/api-services/svls-api";
import {
  BookmakerDTO,
  BookmakerRunnerDTO,
  checkIncludeMultiMarket,
  CURRENCY_TYPE_FACTOR,
  EventDTO,
  useAppDispatch,
  getCurrencyTypeFromToken,
  useAppSelector,
  langData,
  setLoading,
  showToast,
  useBookmaker,
  ThousandFormatter,
  isBmSpecialMarket,
} from "@hypexone/uicore";
import { useMarketLocalState } from "../../../../utils/hooks/storage.hooks";
import MarketTableHeading from "../market-table/MarketTableHeading";
import BookmakerRow from "./BookmakerRow";
import { isMobile } from "react-device-detect";
import Modal from "../../shared/ModalComponent";
import PinIconGray from "../../../../assets/icons/events-icons/pin-icon-gray.svg";
import PinIconGreen from "../../../../assets/icons/events-icons/pin-icon-green.svg";
import InfoIconRoundedWhite from "../../../../assets/icons/info-icon-rounded-white.svg";
import Button from "../../shared/Button/Button";
import { colors } from "../../../../styles/colors";
import { BRAND_DOMAIN } from "../../../../constants/Branding";
import { API_CLIENT } from "../../../../App.utils";
import OneClickBettingCountdown from "../../one-click-betting/OneClickBettingCountdown";
import { BsFillPinFill } from "react-icons/bs";
import MarqueeText from "../../MarqueeText/MarqueeText";
import { FaStar } from "react-icons/fa";

export interface OddsInfoMsg {
  launch: boolean;
  oddsType: string | null;
  eventTypeID: string | null;
}

interface BMProps {
  eventData: EventDTO;
  bmData: BookmakerDTO[];
  loggedIn: boolean;
  getFormattedMinLimit: (num: number) => string;
  getFormattedMaxLimit: (num: number) => string;
  isMultiMarket?: boolean;
  exposureMap: any;
  setBetStartTime?: Function;
  setAddNewBet?: Function;
  loading: boolean;
}

// const multiPinsMap = {
//   purple: RemoveMultiPin,
//   darkvoilet: RemoveMultiPinDarkViolet,
//   darkgreen: RemoveMultiPinDarkGreen,
// };

const Bookmaker: React.FC<BMProps> = ({
  eventData,
  bmData,
  setAddNewBet,
  setBetStartTime,
  isMultiMarket,
  loggedIn,
  exposureMap,
  loading,
}) => {
  const dispatch = useAppDispatch();
  const {
    bets,
    openBets,
    isOneClickBettingLoading,
    bettingInprogress,
    cashoutInProgress,
    betStatusResponse,
  } = useAppSelector((state) => state.betSlip);
  const { domainConfig } = useAppSelector((state) => state.common);
  const cashoutEnabled = useAppSelector((state) => state.common.domainConfig?.cashoutEnabled === true);
  const incentiveEnabled = !!(domainConfig as any)?.incentive_enabled;
  const [multiMarketData, setMultiMarketData] = useMarketLocalState();
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];

  // Initialize useBookmaker hook
  const hookResult = useBookmaker({
    eventData,
    bmData,
    exposureMap,
    bets,
    openBets,
    cashoutInProgress,
    betStatusResponse,
    loggedIn,
    isMultiMarket,
    API: API_CLIENT,
    setBetStartTime: setBetStartTime as ((date: Date) => void) | undefined,
    setAddNewBet: setAddNewBet as ((val: boolean) => void) | undefined,
    multiMarketData,
    setMultiMarketData,
    bettingInprogress,
    isOneClickBettingLoading,
  });

  // Destructure hook values
  const {
    confirmCashout,
    setConfirmCashout,
    coMarket,
    setCoMarket,
    isPopupVisible,
    openPopup,
    closePopup,
    disabledStatus,
    calCashout,
    isHaveCashOut,
    autoCashout: hookAutoCashout,
    handleMultiMarket,
    getMarketAlerts,
    getCashoutState,
    getCashoutDisabled,
    getOutcomeId,
    getOpenBetsPLInArray,
    getTotalPL,
    // getTurboInfo,
    // setConfirmTurboCashout,
    // confirmTurboCashout,
    // turboCoMarket,
    // setTurboCoMarket,
    // turboCashoutFunction,
    // getTurboCashoutData,
    // turboCashoutLoading,
    // isLossCutAvailable,
    // getLossCutProfit,
    // getLossCutDisabled,
    // autoLossCut,
  } = hookResult;

  // Wrapper for autoCashout: accepts optional market (e.g. from header button) or uses coMarket (e.g. from modal)
  const autoCashout = async (m?: BookmakerDTO) => {
    const mkt = m ?? coMarket;
    if (mkt == null) return;
    await hookAutoCashout(mkt);
  };

  const rules = [
    "advantage_or_disadvantage_for_team_txt",
    "suspend_or_void_rights",
    "compare_teams_25_overs",
    "compare_teams_10_overs",
    "contacted_within_7_days",
    "end_two_teams_with_equal_points",
    "tennis_advance_fancy_market",
    "all_bets_will_be_voided",
    "market_will_be_settled_as_three_sets",
    "virtual_cricket",
    "technical_issues_bookmaker_market_will_be_voided",
  ];
  const highLightedIndices = [0, 1, 2, 3, 4, 5, 6, 9];

  return (
    <div className="flex flex-col  rounded-md border border-solid border-neutral-200 max-md:max-w-full">
      {bmData?.map((market, index) => (
        <React.Fragment key={index}>
          {!isMultiMarket ||
          checkIncludeMultiMarket(multiMarketData, market.marketId) ? (
            <>
              <div className="relative">
                {getMarketAlerts(market).showCountdown && (
                  <OneClickBettingCountdown
                    delay={market?.marketLimits?.delay || 0}
                  />
                )}

                {/* Top bar: Sky's slate market title – pin, market name, Zero Commission */}
                <div className="flex items-center justify-between w-full bg-blue4 px-2 py-1 text-xs font-bold text-white">
                  <div className="flex items-center gap-2">
                    {!checkIncludeMultiMarket(
                      multiMarketData,
                      market.marketId,
                    ) ? (
                      <span title="Add To Multi Markets">
                        <BsFillPinFill
                          className="multi-add-icon cursor-pointer h-[100%] text-white hidden md:block"
                          onClick={(e) => {
                            e.stopPropagation();
                            multiMarketData?.length < 10 &&
                              handleMultiMarket(
                                eventData?.competitionId,
                                eventData?.eventId,
                                market.marketId,
                                eventData?.providerName,
                                eventData?.sportId,
                                true,
                              );
                          }}
                        />
                        <img
                          src={PinIconGray}
                          alt="multipin"
                          className="w-5 h-5 md:hidden cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            multiMarketData?.length < 10 &&
                              handleMultiMarket(
                                eventData?.competitionId,
                                eventData?.eventId,
                                market.marketId,
                                eventData?.providerName,
                                eventData?.sportId,
                                true,
                              );
                          }}
                        />
                      </span>
                    ) : (
                      <span title="Remove From Multi Markets">
                        <BsFillPinFill
                          className="multi-remove-icon cursor-pointer h-[100%] text-green-500 hidden md:block"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMultiMarket(
                              eventData?.competitionId,
                              eventData?.eventId,
                              market.marketId,
                              eventData?.providerName,
                              eventData?.sportId,
                              false,
                            );
                          }}
                        />
                        <img
                          src={PinIconGreen}
                          alt="multipin"
                          className="w-5 h-5 md:hidden cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMultiMarket(
                              eventData?.competitionId,
                              eventData?.eventId,
                              market.marketId,
                              eventData?.providerName,
                              eventData?.sportId,
                              false,
                            );
                          }}
                        />
                      </span>
                    )}
                    <span className="capitalize">
                      {market?.marketName?.toLowerCase() ?? "Bookmaker Market"}{incentiveEnabled && market?.commissionEnabled ? (
                        <FaStar className="commission-star" />
                      ) : null}
                    </span>
                    <div className="cursor-pointer">
                      <img
                        onClick={openPopup}
                        src={InfoIconRoundedWhite}
                        alt="info-icon"
                        className="h-[13px] w-[13px] min-w-[13px]"
                      />
                    </div>
                    {isMultiMarket && !isMobile && (
                      <span className="pl-2 text-gray-300">
                        {eventData?.eventName}
                      </span>
                    )}
                  </div>
                  {/* Right: Cashout / Turbo and Loss Cut */}
                  <div className="flex items-center gap-1">
                    {cashoutEnabled &&
                      market?.runners?.length === 2 &&
                      !market?.marketName?.toUpperCase()?.includes("TOSS") &&
                      !isBmSpecialMarket(market.marketName, market.oddType) &&
                      (() => {
                        // const {
                        //   isAvailable: isTurboAvailable,
                        //   label: turboLabel,
                        //   countdown: countdownVal,
                        // } = getTurboInfo?.(market) ?? {
                        //   isAvailable: false,
                        //   label: "",
                        //   countdown: 0,
                        // };
                        const { isProfitable, label: cashoutLabel } =
                          getCashoutState(market);
                        const cashoutDisabled =
                          getCashoutDisabled(market) ||
                          eventData?.eventSuspended === true;
                        return (
                          <Button
                            style={{ background: "#701920" }}
                            className={`px-2 tracking-wide text-white font-bold leading-none relative overflow-hidden text-[11px] transition-all duration-150 ease-in-out rounded-md text-center flex items-center justify-center flex-row h-[26px] cursor-pointer shadow-[0_2px_6px_rgba(0,0,0,0.35)] border border-white/20 ${
                              isProfitable ? "profit" : "loss"
                            }`}
                            disabled={cashoutDisabled}
                            loading={
                              loading ||
                              (cashoutInProgress?.loading &&
                                cashoutInProgress?.marketId === market.marketId)
                            }
                            onClick={() => autoCashout(market)}
                          >
                            <span className="text-white whitespace-nowrap">
                              {(
                                langData?.["cashout"] ?? "Cashout"
                              ).toUpperCase()}
                              {cashoutLabel != null && cashoutLabel !== ""
                                ? ` ${cashoutLabel}`
                                : ""}
                            </span>
                          </Button>
                        );
                        /* Speed Cash - disabled (was else branch of !isTurboAvailable ternary)
                        ) : (
                          <Button
                            style={{ background: "#5bb450" }}
                            className="px-2 tracking-wide text-white font-bold leading-none relative overflow-hidden text-[11px] transition-all duration-150 ease-in-out rounded-md text-center flex items-center justify-center flex-row h-[26px] cursor-pointer shadow-[0_2px_6px_rgba(0,0,0,0.35)] border border-white/20"
                            disabled={
                              !isTurboAvailable ||
                              disabledStatus.includes(
                                (market?.status ?? "").toLowerCase(),
                              ) ||
                              market.suspend === true ||
                              !(
                                `${market?.marketId}:${market?.marketName}` in
                                exposureMap
                              ) ||
                              turboCashoutLoading
                            }
                            loading={loading}
                            onClick={() => {
                              if (countdownVal > 0) return;
                              setTurboCoMarket(market);
                              setConfirmTurboCashout(true);
                            }}
                          >
                            <span className="text-white whitespace-nowrap">
                              {turboLabel || "SPEED CASH"}
                            </span>
                          </Button>
                        );
                        */
                      })()}
                    {/* Loss Cut - disabled
                    {market?.runners?.length === 2 &&
                      !market?.marketName?.toUpperCase()?.includes("TOSS") &&
                      !isBmSpecialMarket(market.marketName, market.oddType) && (
                        <Button
                          className="loss-cut-btn px-2 tracking-wide text-white font-bold leading-none relative overflow-hidden text-[11px] transition-all duration-150 ease-in-out rounded-md text-center flex items-center justify-center flex-row h-[26px] cursor-pointer shadow-[0_2px_6px_rgba(0,0,0,0.35)] border border-white/20"
                          style={{ background: "#5bb450" }}
                          disabled={
                            bettingInprogress ||
                            (getLossCutDisabled &&
                              getLossCutDisabled(market)) ||
                            (cashoutInProgress?.loading &&
                              cashoutInProgress?.marketId === market.marketId)
                          }
                          loading={
                            loading ||
                            (cashoutInProgress?.loading &&
                              cashoutInProgress?.marketId === market.marketId)
                          }
                          onClick={() => autoLossCut && autoLossCut(market)}
                        >
                          <span className="text-white whitespace-nowrap">
                            {(
                              langData?.["loss_cut"] || "Loss Cut"
                            ).toUpperCase()}
                            {typeof getLossCutProfit === "function" &&
                            getLossCutProfit(market) != null
                              ? ` : ₹${Number(getLossCutProfit(market)).toFixed(2)}`
                              : ""}
                          </span>
                        </Button>
                      )}
                    */}
                  </div>
                </div>

                {/* Middle bar: light blue – Bookmaker label, Min/Max, info icon */}
                <div className="flex items-center justify-between w-full bg-blue15 px-4 py-1 text-xs font-bold text-black border-b border-gray6">
                  <div className="flex items-center gap-2"></div>
                  <div className="flex items-center gap-1">
                    <span className="rounded-sm px-4 text-[10px] font-normal text-white bg-blue4">
                      Min
                    </span>
                    <span className="text-[11px] font-semibold">
                      {market?.marketLimits
                        ? ThousandFormatter(
                            market?.marketLimits?.minStake / cFactor,
                          )
                        : 100}
                    </span>
                    <span className="rounded-sm px-4 text-[10px] font-normal text-white bg-blue4">
                      Max
                    </span>
                    <span className="text-[11px] font-semibold">
                      {market?.marketLimits?.maxStake % 1000 === 0
                        ? ThousandFormatter(
                            market?.marketLimits
                              ? market?.marketLimits?.maxStake / cFactor
                              : 5000,
                          )
                        : market?.marketLimits
                          ? market?.marketLimits?.maxStake / cFactor
                          : 5000}
                    </span>
                  </div>
                </div>
                <Modal
                  isOpen={isPopupVisible}
                  onClose={closePopup}
                  content={<div>Popup Content</div>}
                  title="Rules"
                >
                  {rules.map((point, index) => (
                    <div
                      key={index}
                      className={`p-[8px] border-b font-sans font-[450] border-gray-300 flex items-center text-[12px]  ${
                        highLightedIndices.includes(index)
                          ? "text-[#F1556C]"
                          : " text-[#000]"
                      }`}
                    >
                      {langData?.[point] || point}
                    </div>
                  ))}
                </Modal>

                <table className="w-full text-[14px] font-medium text-black bg-yellow1 [&_td]:p-[0.2px] [&_th]:p-0">
                  <MarketTableHeading
                    variant="bookmaker"
                    title1="back"
                    title2="lay"
                    minStake={market.marketLimits?.minStake || 0}
                    maxStake={market.marketLimits?.maxStake || 0}
                    hideLay={isBmSpecialMarket(market.marketName, market.oddType)}
                  />
                  <tbody>
                    {market?.runners
                      ?.filter((bmSelection) => {
                        if (market.marketName === "Genie Combo Special Bet") {
                          return bmSelection.runnerName !== "No winner";
                        }
                        return true;
                      })
                      ?.map((runner, idx) => (
                        <BookmakerRow
                          key={idx}
                          exposureMap={exposureMap}
                          cFactor={cFactor}
                          runner={runner}
                          market={market}
                          eventData={eventData}
                          index={index}
                          setAddNewBet={setAddNewBet}
                          setBetStartTime={setBetStartTime}
                          getOpenBetsPLInArray={getOpenBetsPLInArray}
                          getTotalPL={getTotalPL}
                          hideLay={isBmSpecialMarket(market.marketName, market.oddType)}
                        />
                      ))}

                    {market?.notification ? (
                      <tr>
                        <td colSpan={12} className=" overflow-hidden">
                          <MarqueeText text={market.notification ?? ""} />
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </div>
            </>
          ) : null}
        </React.Fragment>
      ))}
      <Modal
        title="Do you wish to perform cash out?"
        isOpen={confirmCashout}
        onClose={() => setConfirmCashout(false)}
      >
        {/* <div className="flex">
          <Button
            color="primary"
            className="py-2 px-4 bg-orange-700 rounded text-white "
            onClick={() => setConfirmCashout(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            className="py-2 px-4 ml-2 bg-green-600 rounded text-white "
            onClick={() => {
              setLoading(true);
              autoCashout();
              setConfirmCashout(false);
            }}
            disabled={loading}
          >
            {langData?.['cashout']}
          </Button>
        </div> */}
        <div className="grid grid-cols-2 w-full gap-x-2">
          {/* Cancel Button */}
          <Button
            type="button"
            onClick={() => setConfirmCashout(false)}
            className="leading-normal relative overflow-hidden transition duration-150 ease-in-out bg-transparent w-full px-2.5 py-1 border-[1px] border-primary rounded-[4px] flex items-center justify-center cursor-pointer"
          >
            <span className="text-text_Primary text-[16px] font-[700] font-lato">
              cancel
            </span>
          </Button>

          {/* Cashout Button */}
          <div className="w-full">
            <Button
              type="button"
              disabled={loading}
              onClick={() => {
                setLoading(true);
                autoCashout();
                setConfirmCashout(false);
              }}
              className="leading-normal relative overflow-hidden transition duration-150 ease-in-out bg-[#29ab2b] w-full h-[36px] min-h-[36px] px-2.5 py-1 border-[1px] border-success rounded-[4px] flex items-center justify-center cursor-pointer"
            >
              <span className="text-white text-[16px] font-[700] font-lato">
                cashout
              </span>
            </Button>
          </div>
        </div>
      </Modal>

      {/* Turbo Cashout (Speed Cash) Modal - disabled
      <Modal
        title="Speed Cash"
        isOpen={!!confirmTurboCashout}
        onClose={() => {
          setConfirmTurboCashout?.(false);
          setTurboCoMarket?.(null);
        }}
      >
        {turboCoMarket && (
          <>
            <div className="grid grid-cols-2 mb-2 border border-dashed border-black">
              {turboCoMarket.runners?.map((runner) => {
                const key = `${turboCoMarket.marketId}:${turboCoMarket.marketName}`;
                const riskRows = exposureMap[key] as any[];
                const riskMap = new Map(
                  riskRows?.map((r: any) => [
                    r.runnerId,
                    Number(r.userRisk) || 0,
                  ]) ?? [],
                );
                const risk = Number(riskMap.get(runner.runnerId) ?? 0);
                return (
                  <div
                    key={runner.runnerId}
                    className="text-center py-1 border-r border-dashed border-black last:border-r-0"
                  >
                    <div className="text-text_Primary text-[16px] font-[700] font-lato mb-1">
                      {runner.runnerName}
                    </div>
                    <div className="text-text_Primary text-[14px] font-[500] font-lato">
                      ₹{risk.toFixed(2)}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="text-center mb-2">
              <span className="text-text_Primary text-[14px] font-[500] font-lato">
                We are deducting 3% fee on speed cashout.
              </span>
            </div>
            <div className="grid grid-cols-1 w-full gap-2">
              <Button
                type="button"
                disabled={loading}
                onClick={async () => {
                  try {
                    await turboCashoutFunction?.(turboCoMarket);
                    setConfirmTurboCashout?.(false);
                    setTurboCoMarket?.(null);
                  } catch (error: any) {
                    dispatch(
                      showToast({
                        type: "error",
                        message:
                          error?.response?.data?.message || "Speed cash failed",
                      }),
                    );
                  } finally {
                    setConfirmTurboCashout?.(false);
                    setTurboCoMarket?.(null);
                  }
                }}
                className="leading-normal relative overflow-hidden transition duration-150 ease-in-out bg-[#ff6b35] w-full min-h-[36px] px-2.5 py-3 border-[1px] border-orange-500 rounded-[4px] flex items-center justify-center cursor-pointer"
              >
                <span className="text-white text-[16px] font-[700] font-lato">
                  {loading
                    ? "Processing..."
                    : `SPEED CASH - ₹${
                        getTurboCashoutData?.(turboCoMarket)
                          ?.turboCashoutAmount ?? "0.00"
                      }`}
                </span>
              </Button>
            </div>
          </>
        )}
      </Modal>
      */}
    </div>
  );
};

export default Bookmaker;
